import { get as lodashGet } from 'lodash'
import ABTestAPI from '@/api/abTest'
import sentry from '@/services/sentry'

const AI_ONBOARDING_FLAG = 'AI-ONBOARDING'
const APPLIED_GROUPS = ['TREATMENT']

const services = {
  async getAbTest(code) {
    const res = await ABTestAPI.getTest(code)

    return lodashGet(res, 'body.variant', null)
  },
}

const getters = {
  isAiOnboardingAbTestUser: (_, __, rootState) => {
    const group = lodashGet(rootState, `currentUser.abTest.${AI_ONBOARDING_FLAG}`, null)
    return APPLIED_GROUPS.includes(group)
  },
  skippedScreening: (_, __, rootState) => {
    return lodashGet(rootState, 'currentUser.personalInformation.skipUserScreening', false)
  },
  hasDoneScreening: (_, __, rootState) => {
    return lodashGet(rootState, 'currentUser.personalInformation.useAhaSlidesFor', null)
    && lodashGet(rootState, 'currentUser.personalInformation.userProfession', null)
  },
}

const actions = {
  async getOnBoardingDataAction({ dispatch }) {
    await Promise.all([
      dispatch('getAiOnboardingAbTestAction'),
    ])
  },
  async getAiOnboardingAbTestAction({ commit }) {
    try {
      const variant = await services.getAbTest(AI_ONBOARDING_FLAG)
      if (!variant) {
        // eslint-disable-next-line no-console
        console.log('MISSING AI ONBOARDING AB TEST, REMEMBER TO ADD ITS RECORD IN OUR DATABASE')
        return
      }
      commit('updateCurrentABTest', { [AI_ONBOARDING_FLAG]: variant }, { root: true })
    } catch (e) {
      sentry.captureException(e)
    }
  },
}

const onboarding = {
  namespaced: true,
  getters,
  actions,
}

export default onboarding
